import { useCssStateManager } from "../../hooks/use_css_state_manager";
import PriceDisplay from "./price-display";

export type PriceDisplayWithDiscountProps = {
    size?: number;
    price: number;
    discountedPrice: number;
};

export default function PriceDisplayWithDiscount({
    size,
    price,
    discountedPrice
}:PriceDisplayWithDiscountProps)
{
    const cssStateManager = useCssStateManager(["price-display-with-discount"]);
    return (
        <>
            <div className={cssStateManager.getClassNames()}>
                {(price!==discountedPrice)?<>
                    <span className="left-price">
                        <PriceDisplay price={price} size={size} strike />
                    </span>
                    <PriceDisplay price={discountedPrice} size={size} />
                </>:<PriceDisplay price={price} size={size} />}                                
            </div>
            <style jsx>{`
            .price-display-with-discount {
            }

            .left-price {
                padding-right: 8rem;
            }
            `}</style>
        </>
    );
}
